// jQuery solution for mobile menu offcanvas trigger icon toggle
jQuery(function($) {
  var $trigger = $('#mobile-menu-offcanvas-trigger');
  var $iconLink = $trigger.find('.elementor-icon');
  var $icon = $iconLink.find('i.icon');

  $iconLink.on('click', function(e) {
    var expanded = $iconLink.attr('aria-expanded') === 'true';
    $iconLink.attr('aria-expanded', expanded ? 'false' : 'true');
    if (expanded) {
      $icon.removeClass('fas fa-times').addClass('icon-hamburger');
    } else {
      $icon.removeClass('icon-hamburger').addClass('fas fa-times');
    }
  });

  // Initial state sync
  if ($iconLink.attr('aria-expanded') === 'true') {
    $icon.removeClass('icon-hamburger').addClass('fas fa-times');
  } else {
    $icon.removeClass('fas fa-times').addClass('icon-hamburger');
  }
});
